<div
  class="d-inline-flex align-items-start"
  [ngClass]="
    displayColumn()
      ? 'flex-column gap-1 flex-' +
        displayColumn() +
        '-row gap-' +
        displayColumn() +
        '-2'
      : 'gap-2'
  "
>
  <a
    target="_blank"
    [attr.aria-label]="appStoreButtonLink().value?.text"
    [href]="appStoreButtonLink().href"
    [class.inverted]="inverted()"
    id="app-store-button"
    wlTrackLink
    [trackLinkInfo]="{
      rendering: { componentName: 'AppStoreButtonsComponent' },
      field: appStoreButtonLink()?.value?.text || '',
      eventType: 'button-click',
      type: 'button',
    }"
  >
    <wl-app-store-logo />
    <crnt-visually-hidden>{{
      appStoreButtonLink().value?.text
    }}</crnt-visually-hidden>
  </a>
  <a
    target="_blank"
    [attr.aria-label]="googlePlayButtonLink().value?.text"
    [href]="googlePlayButtonLink().href"
    [class.inverted]="inverted()"
    id="google-play-button"
    wlTrackLink
    [trackLinkInfo]="{
      rendering: { componentName: 'AppStoreButtonsComponent' },
      field: googlePlayButtonLink()?.value?.text || '',
      eventType: 'button-click',
      type: 'button',
    }"
  >
    <wl-google-play-logo />
    <crnt-visually-hidden>{{
      googlePlayButtonLink().value?.text
    }}</crnt-visually-hidden>
  </a>
</div>
